import React from 'react';
import { Button, Input, Col, Row, Container, FormGroup, Label } from 'reactstrap';
import api from '../../api';
import TrafficScanningLog from '../../components/TrafficScanningLog';
import './index.css';
  
export default class TrafficScanning extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            siteId: parseInt(this.props.match.params.location_id, 10) || '',
            currentUser: null,
            newScan: {
                location_id: parseInt(this.props.match.params.location_id, 10) || '',
                scanner_device_id: '20014125605518',
            },
            scanningLogs: [],
            currentLocation: null,
        }
    }
    
    // TODO: refactor
    UNSAFE_componentWillMount() {
        this.getCurrentUser();
        this.getScan();
    }
    componentDidMount = () => {
        document.title = "Site Tracking";
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: `userme/me`,
            success: (response) => {
                if (response.result) {
                    this.setState({
                        currentUser: response.result,
                    });
                } else {
                    alert('Failed to get user: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getScan() {
        const { siteId } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `traffic_scanning_log/?q=(page:0,page_size:1000,order_columns:created_on,order_direction:desc,filters:!((col:location,opr:rel_o_m,value:${siteId})))`,
            success: (response) => {
                console.log(response)
                if (response.result) {
                    this.setState({
                        scanningLogs: response.result,
                    });
                } else {
                    alert('Error: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    toogleCreateScan() {
        const { isCreateNew } = this.state;
        this.setState({ isCreateNew: !isCreateNew });
    }
    updateAttribute(attribute_name, value) {
        const { newScan } = this.state;
        newScan[attribute_name] = value;
        this.setState({ newScan });
    }
    getCurrentUserLocation() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.setState({ 
                    currentLocation: {
                        latitude: position.coords.latitude, 
                        longitude: position.coords.longitude
                    },
                })
            },
            err => alert('Error code ' + err.code + ': ' + err.message)
        );
    }
    saveScan() {
        const { newScan, scanningLogs, currentLocation } = this.state;
        if (currentLocation) {
            newScan.latitude = currentLocation.latitude;
            newScan.longitude = currentLocation.longitude;
        }
        api.fetchAPI({
            method: 'post',
            uri: `traffic_scanning_log/create`,
            body: newScan,
            success: (response) => {
                if (response.status === 'ok') {
                    const trafficScanningLog = response.result;
                    this.setState({
                        isCreateNew: false,
                        scanningLogs: [trafficScanningLog, ...scanningLogs],
                    });
                } else {
                    alert('Error: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { scanningLogs, isCreateNew, newScan } = this.state;
        return (
            <Container>
                <div>
                    {!isCreateNew &&
                        <Row className="create-new-scanning-log">
                            <Col xs={12}>
                                <Button
                                    color="primary"
                                    onClick={() => this.toogleCreateScan()}
                                >
                                    Create a new scan
                                </Button>
                            </Col>
                        </Row>
                    }
                    {isCreateNew &&
                        <Row className="create-new-scanning-log">
                            <Col xs={12}>
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input
                                        placeholder="Name"
                                        onChange={(e) => this.updateAttribute('name', e.target.value)}
                                        value={newScan.name}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Input
                                        placeholder="Name"
                                        onChange={(e) => this.updateAttribute('description', e.target.value)}
                                        value={newScan.description}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label>Device ID</Label>
                                    <Input
                                        placeholder="Name"
                                        onChange={(e) => this.updateAttribute('scanner_device_id', e.target.value)}
                                        value={newScan.scanner_device_id}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <Button
                                    color="primary"
                                    onClick={() => this.saveScan()}
                                >
                                    Save
                                </Button>
                                {' '}
                                <Button
                                    color="secondary"
                                    onClick={() => this.toogleCreateScan()}
                                >
                                    Cancel
                                </Button>
                                {' '}
                                <Button
                                    color="info"
                                    onClick={() => this.getCurrentUserLocation()}
                                >
                                    Get lat long
                                </Button>
                            </Col>
                        </Row>
                    }
                    <Row>
                        {scanningLogs &&
                            scanningLogs.map(scanningLog =>
                            <Col key={scanningLog.id} xs={12} style={{ marginBottom: 24 }}>
                                <TrafficScanningLog scanningLog={scanningLog} />
                            </Col>
                        )}
                    </Row>
                </div>
            </Container>
        )
    }
}
